<template>
  <v-container fill-height fluid grid-list-xl>
    <div v-if="loading">Carregando membros...</div>
    <cpn-customer-list
      :users="users"
      :error="error"
      v-if="!loading"
    ></cpn-customer-list>
  </v-container>
</template>
<script>
import CustomerList from "../components/customer/CustomerList";
// import { GET_USERS } from '../graphql/users'
import { getUsers } from "../services/users";
export default {
  components: {
    cpnCustomerList: CustomerList,
  },
  data: () => ({
    users: [],
    customer: {},
    loading: false,
    error: null,
  }),
  created() {
    this.loading = true;
    getUsers({
      orderBy: { field: "created_at", direction: "desc" },
    }).onSnapshot({ includeMetadataChanges: true }, (res) => {
      const changes = res.docChanges();
      changes.forEach((change) => {
        if (change.type === "added") {
          this.users.push({
            ...change.doc.data(),
            id: change.doc.id,
          });
          this.loading = false;
        } else {
          this.loading = false;
        }
      });
    });
  },
};
</script>
